import React from 'react';

import { deleteTag } from '../../../../../element/tags/tagsService';
import { useTranslator } from '../../../../../components/i18n/useTranslator';

import Icon from '../../../../../components/icons/Icon';

import { TagsToolbarPopupProps } from './popup/TagsToolbarPopup';

const TagDeleteButton: React.FC<TagsToolbarPopupProps> = ({ tag, closePopup }) => {
    const translate = useTranslator('popup', 'tags.edit');

    const handleDeleteTag = () => {
        if (!tag) return;

        deleteTag(tag._id);
        closePopup();
    };

    return (
        <div className="TagDeleteButton mt-2">
            <div className="w-full flex cursor-pointer" onClick={handleDeleteTag}>
                <Icon name="task-trash" />
                <span className="text-sm ml-1">{translate('delete')}</span>
            </div>
        </div>
    );
};

export default TagDeleteButton;
